import Types from './Types';

const INITIAL_STATE = {
    bookmark: [

    ],
    missed: [

    ],
    isLoading: false,
    count: '',
    questionBuckets: []
};

export default function questions(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_BOOKMARKED_QUESTIONS_SUCCESS: {
            return {
                ...state,
                bookmark: payload.data,
                count: payload.data.length
            };
        }

        case Types.GET_MISSED_QUESTIONS_SUCCESS: {
            return {
                ...state,
                missed: payload.data,
                count: payload.data.length
            };
        }




        case Types.ADD_QUESTIONS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.GET_QUESTION_BUCKETS_FOR_STUDENT_SUCCESS: {
            return {
                ...state,
                questionBuckets: payload.data
            };
        }

        case Types.GET_QUESTION_BUCKETS_FOR_STUDENT_FAIL: {
            return {
                ...state,
                questionBuckets: []
            };
        }

        case Types.GET_QUESTION_BUCKETS_FOR_STUDENT_REQUEST: {
            return {
                ...state,
                isLoading: true
            };
        }

        default: {
            return state;
        }
    }
}
